module.exports={labels:["C. レイター","0. シード","子会社","B. ミドル","A. アーリー","上場"],values:[2,2,3,7,8,10]};